import React from 'react'
import classes from './pose-img.module.sass'

const OnePoseGrid = ({ items }) => (
  <div className={classes.poses1}>
    {items[0]}
  </div>
)

export default OnePoseGrid
